import { useEffect, useState } from 'react';

export default function OrderInvoice({
    api, busy, invoiceNumber, orderId, run,
}) {
    const [invoiceUrl, setInvoiceUrl] = useState(null);

    useEffect(
        () => () => {
            if (invoiceUrl) URL.revokeObjectURL(invoiceUrl);
        },
        [invoiceUrl],
    );

    const showPdf = () => run(async () => {
        const blob = await api(`/orders/${orderId}/invoice.pdf`, { pdf: true });
        setInvoiceUrl(URL.createObjectURL(blob));
    });

    const togglePdf = () => {
        if (invoiceUrl) {
            setInvoiceUrl(null);
            return;
        }
        showPdf();
    };

    return (
        <>
            <div className="po-actions">
                <button
                    type="button"
                    disabled={busy}
                    aria-expanded={Boolean(invoiceUrl)}
                    aria-controls="order-invoice-viewer"
                    onClick={togglePdf}>
                    {invoiceUrl ? 'Hide invoice' : 'View / download invoice'}
                </button>
            </div>
            {invoiceUrl && (
                <div
                    id="order-invoice-viewer"
                    className="po-invoice">
                    <a
                        href={invoiceUrl}
                        target="_blank"
                        rel="noreferrer">
                        Open PDF in a new tab
                    </a>
                    <a
                        href={invoiceUrl}
                        download={`${invoiceNumber}.pdf`}>
                        Download PDF
                    </a>
                    <iframe
                        title="Invoice PDF"
                        src={invoiceUrl} />
                </div>
            )}
        </>
    );
}
